import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';
import * as _ from "lodash";
import * as moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-manage-google-sheet',
  templateUrl: './manage-google-sheet.component.html',
  styleUrls: ['./manage-google-sheet.component.scss'],
})
export class ManageGoogleSheetComponent implements OnInit {
  storeManageId: any;
  googleSheetError: string;
  googleSheetNameError: string;
  googleSheetId: string;
  googleSheetName: string;
  selectedId: string;
  statusText29: string;
  statusText30: string;
  statusText31: string;
  statusText32: string;
  statusText33: string;
  statusText34: string;
  statusText35: string;
  scheduleStores: any = [];
  sync: string = 'N';
  syncId: any;
  selectedItems: any = '';
  store: any = {
    syncType: "",
    syncTypeProducts: "",
    orderStatus: []
  };
  selectPeriodicType = "";
  tabClicked = "ORDERS";
  tabActive: string = '';
  scheduleOrders: any;
  index: any;
  deleteApiPop: string = 'N';
  apiKeyError: string;
  manualImportsOrders: boolean = false;
  apiKey: string;
  storeManage: any = {};
  mId: any;
  instructions: string = 'N';
  configurationList: any = [];
  channelNameError: string;

  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router) {
    this.selectedId = this.route.snapshot.params['id'];
    this.getByStoreId(this.route.snapshot.params['id']);
    this.api.getConfigurationsList(this.user.accountOwnerId, this.user.organizationId, this.route.snapshot.paramMap.get('id')).subscribe((data: any) => {
      this.configurationList = data.getStoreConfigResponseList;
      this.configurationList.forEach((n) => {
        if (n.syncType === 'ORDERS') {
          this.syncId = n.id;
          if (n.manualSyncOption === 'ACTIVE') {
            this.manualImportsOrders = true;
          } else {
            this.manualImportsOrders = false;
          }
          if (n.scheduleOption === 'ACTIVE') {
            this.scheduleOrders = true;
          } else {
            this.scheduleOrders = false;
          }
        }
      });
    }, err => {
      console.log(err);
    });
  }

  channelNameBlur() {
    this.channelNameError = "";
    if (!this.storeManage.connectionName) {
      this.channelNameError = 'Please enter channel name';
    }
  }

  googleSheetIdBlur() {
    this.googleSheetError = "";
    if (!this.storeManage.version) {
      this.googleSheetError = 'Please enter google sheetId';
    }
  }

  verifyGoogleSheet() {
    this.g.loaderDisplay = "display";
    this.channelNameError = "";
    this.googleSheetError = "";
    this.googleSheetNameError = "";

    if (!this.storeManage.connectionName) {
      this.channelNameError = 'Please enter channel name';
    }
    if (!this.storeManage.clientId) {
      this.googleSheetError = 'Please enter google sheetId';
    }
    if (!this.storeManage.userName) {
      this.googleSheetNameError = 'Please enter google sheet Name';
    }

    if (this.channelNameError != "" || this.googleSheetError != "" || this.googleSheetNameError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/google-sheets/validate', {
      "accountOwnerId": this.user.accountOwnerId,
      "connectionName": this.storeManage.connectionName,
      "organizationId": this.user.organizationId,
      "sheetId": this.storeManage.clientId,
      "sheetName": this.storeManage.userName
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success(data['message']);
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  showInstructions() {
    this.instructions = 'Y';
  }

  ngOnInit() {
    this.storeManageId = this.route.snapshot.paramMap.get('id');
    if (this.storeManageId) {
      this.api.getStoreManagementById(this.storeManageId, this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
        this.storeManage = data;
        this.mId = this.storeManage.id;
      }, err => {
        this.alertService.error('Error', "Failed to get data");
      });
    }
  }

  syncProcess() {
    this.statusText29 = '';
    this.statusText30 = '';
    this.statusText31 = '';
    this.statusText32 = '';
    this.statusText33 = '';
    this.statusText34 = '';
    this.statusText35 = '';

    if (this.store.syncType == 'PERIODICALLY') {
      if (this.store.startDate == '' || this.store.startDate === null ||
        this.store.startDate === undefined ||
        this.store.startDate === 'undefined') {
        this.statusText30 = 'Please select start date';
      }
      if (this.store.duration == '' || this.store.duration === null ||
        this.store.duration === undefined ||
        this.store.duration === 'undefined') {
        this.statusText32 = 'Please select frequency';
      }
      if (this.store.durationType == '' || this.store.durationType === null ||
        this.store.durationType === undefined ||
        this.store.durationType === 'undefined') {
        this.statusText33 = 'Please select duration type';
      }
      if (this.statusText30 != '' ||
        this.statusText32 != '' || this.statusText33 != '') {
        this.g.loaderDisplay = '';
        return false;
      }
    }
    if (this.store.syncType != 'PERIODICALLY') {
      if (this.store.sstartDate == '' || this.store.sstartDate === null ||
        this.store.sstartDate === undefined ||
        this.store.sstartDate === 'undefined') {
        this.statusText34 = 'Please select start date';
        return false;
      }
    }

    this.g.loaderDisplay = 'display';
    let configSchedule;
    if (this.store.syncType == 'PERIODICALLY') {
      configSchedule = {
        'accountOwnerId': this.user.accountOwnerId,
        'organizationId': this.user.organizationId,
        'requestList': [{
          'accountOwnerId': this.user.accountOwnerId,
          'duration': this.store.duration,
          'durationType': this.store.durationType,
          'organizationId': 1,
          'syncType': this.store.syncType,
          'storeId': this.storeManage.id,
          'startDate': this.store.startDate,
          'endDate': this.store.endDate
        }]
      };
    } else {
      configSchedule = {
        'accountOwnerId': this.user.accountOwnerId,
        'organizationId': this.user.organizationId,
        'requestList': [{
          'accountOwnerId': this.user.accountOwnerId,
          'organizationId': 1,
          'syncType': this.store.syncType,
          'storeId': this.storeManage.id,
          'startDate': this.store.sstartDate,
          'endDate': this.store.eendDate
        }]
      }
    }
    ;


    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http
      .post(
        environment.apiUrl + 'api/configureSchedulingTime', configSchedule,
        { headers: header1 })
      .subscribe(
        data => {
          this.g.loaderDisplay = '';
          if (data['code'] == 200) {
            if (this.store.syncType == 'PERIODICALLY') {
              this.store.duration = '';
              this.store.durationType = '';
              this.store.startDate = '';
              this.store.endDate = '';
            } else {
              this.store.sstartDate = '';
              this.store.eendDate = '';
            }

            this.getByStoreId(this.storeManage.id);
            this.alertService.success('Schedule', 'Created Successfully');
          }
          this.sync = 'N';
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = '';
        });
  }


  getByStoreId(storeId) {
    this.g.loaderDisplay = 'display';
    this.api.getByStoreId(this.user.accountOwnerId, this.user.organizationId, this.route.snapshot.paramMap.get('id')).subscribe((data: any) => {
      this.scheduleStores = data.getManageStoreInfoResponses;
      this.g.loaderDisplay = '';
    }, err => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = '';
    });
  }

  getGoogleSheetData() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/google-sheets' , this.route.snapshot.paramMap.get('id'),
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
          this.alertService.success('Google Sheet', 'Data Fetched Successfully');
      },
      (err: HttpErrorResponse) => {
      this.g.loaderDisplay = "";
      });
  }

  removeStore(index) {
    this.deleteApiPop = 'Y';
    this.index = index;
  }


  openDetailSection(sectionName) {
    this.tabActive = sectionName;
    if (this.manualImportsOrders) {
      this.selectPeriodicType = "Date Range";
    } else {
      this.selectPeriodicType = "";
    }
    if (this.scheduleOrders) {
      this.store.syncType = "PERIODICALLY";
    } else {
      this.store.syncType = "";
    }
  }

  dateChangeSd(startDate) {
    if (this.store.endDate) {
      this.store.endDate = '';
    }
    document.getElementById("endDate").setAttribute('min', startDate);
  }

  closePopup() {
    this.deleteApiPop = 'n';
  }


  deleteSchedule(id, index) {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/deleteSchedule', {
      "accountOwnerId": this.user.accountOwnerId,
      "id": id,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.scheduleStores.splice(index, 1);
          this.alertService.success('', 'Schedule Deleted Successfully');
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  submitAll() {
    let request: any = {};
    let syncType = "";

    request = {
      "manualSyncOption": this.manualImportsOrders ? "ACTIVE" : "IN_ACTIVE",
      "organizationId": 1,
      "storesManagementId": this.storeManageId,
      "scheduleOption": this.scheduleOrders ? "ACTIVE" : "IN_ACTIVE",
      "syncStatuses": this.selectedItems,
      "syncType": this.tabClicked,
      "additionalSyncStatuses": "",
    };
    if (this.syncId !== '') {
      request.id = this.syncId;
    }


    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createStoreConfigurations', request,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.syncId = data['id'] || '';
        }
        this.alertService.success('Status', 'Submitted Successfully');

      },
      );
  }


    updateGoogleSheetStatus() {
        this.g.loaderDisplay = 'display';
        this.api.updateGoogleSheetData(this.route.snapshot.paramMap.get('id'), this.user.accountOwnerId, this.user.organizationId).subscribe((data:
        any) =>{
            if (data['code'] == 200) {
                this.g.loaderDisplay = '';
                this.alertService.success(data['message']);
            } else if (data['code'] == 400) {
                this.g.loaderDisplay = '';
                this.alertService.error(data['message']);
            }
            this.g.loaderDisplay = '';
        }, err => {
            this.g.loaderDisplay = "";
            this.alertService.error('Error', err);
           });
    }

}
